<template>
  <v-layout>
    <global-header />

    <!-- <global-left /> -->

    <v-main>
      <!-- Provides the application the proper gutter -->

      <v-container fluid class="pa-0">
        <v-row>
          <!-- <v-col v-if="!mobile" sm="3" cols="12" :style="!mobile ? 'max-width:300px; min-width:300px;' : ''"> -->
          <v-col sm="3" cols="12" :style="!mobile ? 'max-width:360px; min-width:360px;' : ''">
            <globalLeft />
          </v-col>
          <v-col>
            <!-- If using vue-router -->
            <slot />
          </v-col>
        </v-row>
      </v-container>
    </v-main>

    <Teleport :to="teleportTo">
      <v-overlay
        v-model="isLoading"
        class="align-center justify-center"
        :persistent="true"
        :close-on-content-click="false"
      >
        <v-progress-circular color="primary" indeterminate size="64"></v-progress-circular>
      </v-overlay>

      <snackbar :show="show"></snackbar>
    </Teleport>

    <global-footer />
  </v-layout>
</template>

<script setup>
import globalHeader from '@/layouts/imports/header'
import globalLeft from '@/layouts/imports/left'
import globalFooter from '@/layouts/imports/footer'
import snackbar from '@/layouts/imports/snackbar'
import { useTheme, useDisplay } from 'vuetify'

const { width, mobile } = useDisplay()
const theme = useTheme()
const pimTheme = useCookie('pim_theme')

const progressbarStore = useProgressbarStore()
const { isLoading, teleportTo } = storeToRefs(progressbarStore)
const { show } = useSnackbarStore()

// data

// method
theme.global.name.value = pimTheme.value || 'light'
</script>

<style scoped></style>
